
namespace RioERP.Carts {
    export class CartColumns {
        static columnsKey = 'Carts.Cart';
    }
}